import React from 'react';
import { Link, NavLink } from 'react-router-dom';
import { history } from '../../utils/helpers';
import { MdMenu } from "react-icons/md";
import { FaUser } from "react-icons/fa";

const onPaths = (paths) => {
  return (match, location) => {
    return paths.includes(location.pathname);
  };
}

const Header = (props) => {
  const { location } = history;
  return (
    <>
    {
      location.pathname === '/' ?
      (<nav className="navbar navbar-expand navbar-light fixed-top sm-light" >
        <a className="navbar-brand" href="#">
          <img className="navbar-logo" src={require("../../assets/logo-provincie-noord-holland.png")} alt="Beta Version" />
        </a>
        <div className="navbar-collapse collapse" id="pallmaxNavBar" aria-expanded="false">
          <ul className="nav navbar-nav navbar-right ml-auto">
            {/*<FaUser size={20} color="white" />*/}
          </ul>
        </div>
      </nav>) :
      (<nav className="navbar navbar-expand navbar-light fixed-top sm-light" >
        <a className="navbar-brand" href="#">
          <img className="navbar-logo" src={require("../../assets/logo-provincie-noord-holland.png")} alt="Beta Version" />
        </a>
        {/*<div className="navbar-collapse collapse" id="pallmaxNavBar" aria-expanded="false">
          <ul className="navbar-nav m-auto stepper stepper-horizontal">
            <li className="step">
              <NavLink exact className="nav-link" to="/step/one/substep/1" isActive={onPaths(["/step/one/substep/1", "/step/one/substep/2"])}>
                <span className="circle active">1</span>
              </NavLink>
            </li>
            <li className="line"></li>
            <li className="step">
              <NavLink exact className="nav-link" to="/step/two/substep/1" isActive={onPaths(["/step/two/substep/1", "/step/two/substep/2"])}>
                <span className="circle">2</span>
              </NavLink>
            </li>
            <li className="line"></li>
            <li className="step">
              <NavLink exact className="nav-link" to="/step/three">
                <span className="circle">3</span>
              </NavLink>
            </li>
            <li className="line"></li>
            <li className="step">
              <NavLink exact className="nav-link" to="/step/four">
                <span className="circle">4</span>
              </NavLink>
            </li>
            <li className="line"></li>
            <li className="step">
              <NavLink exact className="nav-link" to="/step/five">
                <span className="circle">5</span>
              </NavLink>
            </li>
            <li className="line"></li>
            <li className="step">
              <NavLink exact className="nav-link" to="/step/six">
                <span className="circle">6</span>
              </NavLink>
            </li>
          </ul>
        </div>*/}
      </nav>)
    }
    </>
  );
}

export default Header;